<div class="m-wizard__head m-portlet__padding-x">
  <div class="m-wizard__progress">
    <div class="progress">
      <div class="progress-bar" role="progressbar"  aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>
  <div class="m-wizard__nav">
    <div class="m-wizard__steps">
      <div class="m-wizard__step m-wizard__step--current" >
        <a href="#"  class="m-wizard__step-number">
          <span>
            <i class="fa  flaticon-placeholder"></i>
          </span>
        </a>
        <div class="m-wizard__step-info">
          <div class="m-wizard__step-title">
            Informações
          </div>
        </div>
      </div>
      <div class="m-wizard__step" >
        <a href="#" class="m-wizard__step-number">
          <span>
            <i class="fa  flaticon-layers"></i>
          </span>
        </a>
        <div class="m-wizard__step-info">
          <div class="m-wizard__step-title">
            Descrição
          </div>
        </div>
      </div>
      <div class="m-wizard__step" >
        <a href="#" class="m-wizard__step-number">
          <span>
            <i class="la-file-text"></i>
          </span>
        </a>
        <div class="m-wizard__step-info">
          <div class="m-wizard__step-title">
            Resumo
          </div>
        </div>
      </div>
      <div class="m-wizard__step" >
          <a href="#" class="m-wizard__step-number">
            <span>
              <i class="fa  flaticon-layers"></i>
            </span>
          </a>
          <div class="m-wizard__step-info">
            <div class="m-wizard__step-title">
              Benefícios
            </div>
          </div>
      </div>
      <div class="m-wizard__step" >
        <a href="#" class="m-wizard__step-number">
          <span>
            <i class="fa  flaticon-layers"></i>
          </span>
        </a>
        <div class="m-wizard__step-info">
          <div class="m-wizard__step-title">
            Entregáveis
          </div>
        </div>
      </div>
      <div class="m-wizard__step" >
        <a href="#" class="m-wizard__step-number">
          <span>
            <i class="fa  flaticon-layers"></i>
          </span>
        </a>
        <div class="m-wizard__step-info">
          <div class="m-wizard__step-title">
            Premissas
          </div>
        </div>
      </div>
      <div class="m-wizard__step" >
        <a href="#" class="m-wizard__step-number">
          <span>
            <i class="fa  flaticon-layers"></i>
          </span>
        </a>
        <div class="m-wizard__step-info">
          <div class="m-wizard__step-title">
            Situação
          </div>
        </div>
      </div>
      <div class="m-wizard__step" >
        <a href="#" class="m-wizard__step-number">
          <span>
            <i class="la-exclamation-triangle"></i>
          </span>
        </a>
        <div class="m-wizard__step-info">
          <div class="m-wizard__step-title">
            Impactos e Riscos
          </div>
        </div>
      </div>
      <div class="m-wizard__step" >
        <a href="#" class="m-wizard__step-number">
          <span>
            <i class="fa  flaticon-layers"></i>
          </span>
        </a>
        <div class="m-wizard__step-info">
          <div class="m-wizard__step-title">
            Prazo
          </div>
        </div>
      </div>
      <div class="m-wizard__step" >
        <a href="#" class="m-wizard__step-number">
          <span>
            <i class="la-usd"></i>
          </span>
        </a>
        <div class="m-wizard__step-info">
          <div class="m-wizard__step-title">
            Investimento
          </div>
        </div>
      </div>
    </div>
  </div>
</div>